import { render } from "./RemovableGoogleMapsItem.vue?vue&type=template&id=36c5e47e&scoped=true&ts=true"
import script from "./RemovableGoogleMapsItem.vue?vue&type=script&lang=ts"
export * from "./RemovableGoogleMapsItem.vue?vue&type=script&lang=ts"

import "./RemovableGoogleMapsItem.vue?vue&type=style&index=0&id=36c5e47e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c5e47e"]])

export default __exports__